/* This example requires Tailwind CSS v2.0+ */
import ecuador from './images/flags/ecuador.png'
import qatar from './images/flags/qatar.png'
import england from './images/flags/england.png'
import iran from './images/flags/iran.png'
import netherlands from './images/flags/netherlands.png'
import senegal from './images/flags/senegal.png'
import usa from './images/flags/usa.png'
import wales from './images/flags/wales.png'
import argentina from './images/flags/argentina.png'
import saudiarabia from './images/flags/saudiarabia.png'
import denmark from './images/flags/denmark.png'
import tunisia from './images/flags/tunisia.png'
import draw from './images/flags/draw.png'
import winicon from './images/winicon.png'
import loseicon from './images/loseicon.png'

const transactions = [
    {
      status: 'WON',
      statustype: 'win',
      game: 'QAT V ECU',
      teamlogo: ecuador,
      team: 'ECU',
      position: 'Bought',
      contracts: '20',
      entrypremium: '0.6 ICP',
      payout: '20 ICP',
      profitloss: '8 ICP',
      profittype: 'positive',
      funicon: winicon,
    },
    {
      status: 'LOST',
      statustype: 'lost',
      game: 'ENG V IRA',
      teamlogo: england,
      team: 'ENG',
      position: 'Sold',
      contracts: '30',
      entrypremium: '0.3 ICP',
      payout: '0 ICP',
      profitloss: '-21 ICP',
      profittype: 'negative',
      funicon: loseicon,
    },
    {
      status: 'WON',
      statustype: 'win',
      game: 'SEN V NET',
      teamlogo: netherlands,
      team: 'NET',
      position: 'Bought',
      contracts: '7',
      entrypremium: '0.4 ICP',
      payout: '7 ICP',
      profitloss: '4.2 ICP',
      profittype: 'positive',
      funicon: winicon,
    },
    // More transactions...
  ]
  
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  export default function Example() {
    return (

<div className="max-w-4xl mx-auto py-1 sm:pb-24 lg:max-w-7xl">
      <div className="sm:px-6 lg:px-8">
        <div className="mt-8 flex flex-col">
          <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-10">
            <div className="inline-block min-w-full py-2 align-middle px-5">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead className="bg-gradient-to-br from-purple-600 to-orange-300">
                    <tr>
                    <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-bold text-gray-900"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap py-3.5 pl-4 pr-3 text-center text-sm font-bold text-gray-900 sm:pl-6 "
                      >
                        Match
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-bold text-gray-900"
                      >
                      
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-bold text-gray-900"
                      >
                        Market
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-bold text-gray-900"
                      >
                        Position
                      </th>
                      <th
                        scope="col"
                       className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-bold text-gray-900"
                      >
                        Contracts  
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-bold text-gray-900"
                      >
                        Entry Price/Reward
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-bold text-gray-900"
                      >
                       Payout
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-bold text-gray-900"
                      >
                        Profit/Loss
                      </th>
                      <th
                        scope="col"
                        className="whitespace-nowrap px-2 py-3.5 text-center text-sm font-bold text-gray-900"
                      >

                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-300 bg-white bg-opacity-80 hover:bg-gray-100 shadow">
                    {transactions.map((transaction) => (
                      <tr key={transaction.game}>
                        <td className= {classNames(transaction.statustype==='win'?'text-green-600':'text-red-600','whitespace-nowrap text-center text-sm')}>
                            {transaction.status}
                          </td>
                        <td className="whitespace-nowrap text-center text-sm font-bold text-gray-900 sm:pl-6">
                          {transaction.game}
                        </td>
                        <td className="whitespace-nowrap mx-auto py-5 flex-shrink-0 flex items-center justify-end">
                        <a>
                          <img
                            className="h-7 w-7"
                            src={transaction.teamlogo}
                            alt="Logo"
                          />
                        </a>
                        </td>
                        <td className="whitespace-nowrap text-center text-sm font-bold text-gray-900">
                          {transaction.team}
                        </td>
                        <td className="whitespace-nowrap text-center text-sm text-gray-900">{transaction.position}</td>
                        <td className="whitespace-nowrap text-center text-sm text-gray-900">{transaction.contracts}</td>
                        <td className= "whitespace-nowrap text-center text-sm text-gray-900">{transaction.entrypremium}</td>
                        <td className= "whitespace-nowrap text-center text-sm text-gray-900">{transaction.payout}</td>
                        <td className= {classNames(transaction.profittype==='positive'?'text-green-600':'text-red-600','whitespace-nowrap text-center text-sm')}>{transaction.profitloss}</td>
                        <td className="whitespace-nowrap mx-auto py-5 flex-shrink-0 flex items-center justify-start">
                        <a>
                          <img
                            className="h-7 w-7"
                            src={transaction.funicon}
                            alt="Logo"
                          />
                        </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    )
  }
  